import React from 'react'

const AboutUs = () => {
    console.log("About Us");
    return (
        <div>AboutUs</div>
    )
}

export default AboutUs